import * as React from 'react';

function VerificationError() {
  return (
    <div className="sm:mx-auto sm:w-full sm:max-w-md">
      <div className="px-4 py-8 bg-white shadow sm:rounded-lg sm:px-10">
        <div className="sm:mx-auto sm:w-full sm:max-w-md">
          <div className="p-3 mt-3 text-center text-red-800 bg-red-100 rounded-md">
            <p data-cy="verification-error" className="mb-3">
              Please verify your email address to access OncoLens Collaborate.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export { VerificationError };
